module.exports = __webpack_public_path__ + "img/fieldturf.f14713c.png";